import { Pipe, PipeTransform } from '@angular/core';
import { Shared } from './shared.service';
@Pipe({
  name: 'productSort',
  pure: true
})
export class ProductSortPipe implements PipeTransform {

  constructor(public shared: Shared){}

  transform(value: any, search_term?: any): any {
    if(!value){
        this.shared.product_query.next('everything');
        return [];
    }
    if(search_term === '' || search_term === null || search_term === undefined){
        let arr = [];
        let letters = '';
        value.forEach(product => {
            if(letters.includes(product.name[0])){
                arr[letters.indexOf(product.name[0])].products.push(product);
            } else {
                letters += product.name[0];
                arr.push({letter:product.name[0], products:[product]});
            }
        });
        //console.log(arr);
        return arr;
    }
    let arr = [];
    let letters = '';
    value.forEach(product => {
        for(let prop in product){
            if(product[prop] === null || typeof product[prop] === 'object' || prop === "image"){
                continue;
            }

            if(product[prop].toString().toLowerCase().includes(search_term.toLowerCase())){
                if(letters.includes(product.name[0])){
                    arr[letters.indexOf(product.name[0])].products.push(product);
                } else {
                    letters += product.name[0];
                    arr.push({letter:product.name[0], products:[product]});
                }
                break;
            }
        }
    });
    return arr;
  }

}



// WEBPACK FOOTER //
// ./src/app/product-sort.pipe.ts